// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestTags-cls1_5XL","cls2":"ResearchInterestTags-cls2_M46 ResearchInterestTags-cls1_5XL"};